function appropriateSearchPlaceholder(currency: string): string[] {
  switch (currency) {
    case 'AUD':
      return ['"Kmart in Sydney"'];
    case 'EUR':
      return ['"Kaufland in Germany"'];
    case 'GBP':
      return ['"Asda in London"'];
    case 'HKD':
      return ['"PARKnSHOP in Hong Kong"'];
    case 'JPY':
      return ['"UNIQLO in Tokyo"'];
    case 'KRW':
      return ['"E-Mart in Seoul"'];
    case 'MXN':
      return ['"Walmart in Mexico City"'];
    case 'MYR':
      return ['"AEON BiG in Kuala Lumpur"'];
    case 'NZD':
      return ['"FreshChoice in Auckland"'];
    case 'SGD':
      return ['"FairPrice in Singapore"'];
    case 'THB':
      return ['"7-Eleven in Bangkok"'];
    case 'USD':
      return ['"Walmart in Chicago"'];
    case 'ZAR':
      return ['"Shoprite in Midrand"'];
    default:
      return ['"Walmart in Toronto"'];
  }
}

function appropriateToolTip(currency: string): string[] {
  switch (currency) {
    case 'AUD':
      return [
        '"Australia", "New South Wales" or "Sydney"',
        '"Kmart in Sydney", "Barber shop in Melbourne"',
        '"Kmarts in Sydney"',
        '"Kmart in Sydney"',
      ];
    case 'EUR':
      return [
        '"France", "Ile de France" or "Paris"',
        '"Kaufland in Germany", "Barber shop in Madrid"',
        '"Kauflands in Germany"',
        '"Kaufland in Germany"',
      ];
    case 'GBP':
      return [
        '"United Kingdom", "England" or "Manchester"',
        '"Asda in London", "Barber shop in Tottenham"',
        '"Asdas in London"',
        '"Asda in London"',
      ];
    case 'HKD':
      return [
        '"Hong Kong"',
        '"PARKnSHOP in Hong Kong", "Barber shop in Hong Kong"',
        '"PARKnSHOPs in Hong Kong"',
        '"PARKnSHOP in Hong Kong"',
      ];
    case 'JPY':
      return [
        '"Japan", "Kanto" or "Tokyo"',
        '"UNIQLO in Tokyo", "Barber shop in Kyoto"',
        '"UNIQLOs in Tokyo"',
        '"UNIQLO in Tokyo"',
      ];
    case 'KRW':
      return [
        '"South Korea" or "Seoul"',
        '"E-Mart in Seoul", "Barber shop in Seoul"',
        '"E-Marts in Seoul"',
        '"E-Mart in Seoul"',
      ];
    case 'MXN':
      return [
        '"Mexico" or "Mexico City"',
        '"Walmart in Mexico City", "Barber shop in Mexico City"',
        '"Walmarts in Mexico City"',
        '"Walmart in Mexico City"',
      ];
    case 'MYR':
      return [
        '"Malaysia" or "Kuala Lumpur"',
        '"AEON BiG in Kuala Lumpur", "Barber shop in Kuala Lumpur"',
        '"AEON BiGs in Kuala Lumpur"',
        '"AEON BiG in Kuala Lumpur"',
      ];
    case 'NZD':
      return [
        '"New Zealand" or "Auckland"',
        '"FreshChoice in Auckland", "Barber shop in Wellington"',
        '"FreshChoices in Auckland"',
        '"FreshChoice in Auckland"',
      ];
    case 'SGD':
      return [
        '"Singapore" or "Woodlands"',
        '"FairPrice in Singapore", "Barber shop in Woodlands"',
        '"FairPrices in Singapore"',
        '"FairPrice in Singapore"',
      ];
    case 'THB':
      return [
        '"Thailand" or "Bangkok"',
        '"7-Eleven in Bangkok", "Barber shop in Thailand"',
        '"7-Elevens in Bangkok"',
        '"7-Eleven in Bangkok"',
      ];
    case 'USD':
      return [
        '"USA", "Illinois" or "Chicago"',
        '"Walmart in Chicago", "Barber shop in Los Angeles"',
        '"Walmarts in Chicago"',
        '"Walmart in Chicago"',
      ];
    case 'ZAR':
      return [
        '"South Africa" or "Cape Town"',
        '"Shoprite in Midrand", "Barber shop in Durban"',
        '"Shoprites in Midrand"',
        '"Shoprite in Midrand"',
      ];
    default:
      return [
        '"Canada", "Ontario" or "Toronto"',
        '"Walmart in Toronto", "Barber shop in Ottawa"',
        '"Walmarts in Toronto"',
        '"Walmart in Toronto"',
      ];
  }
}

function splitGenericGeofenceNames(searchRaw: string, countryCode: string, geofenceType: string): string[] {
  const datasetWithSpaces: [string, string][] = [
    ['USA', 'county'],
    ['GBR', 'postal'],
  ];
  return searchRaw
    .split(/[\n,]+/)
    .map((x: string) =>
      datasetWithSpaces.some(([country, type]) => country === countryCode && type === geofenceType)
        ? x.trim().replace(/  +/g, ' ')
        : x.replace(/ /g, ''),
    )
    .map((x) => `${x}`);
}

const defaultEcpmParams = {
  ad_duration: 0,
  buyer_organization_dsp_id: null,
  buyer_organization_id: null,
  daypart:
    '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
  demographic_ids: [],
  from_date: null,
  geofencegroup_ids: [],
  geofencegroup_exclusion_ids: [],
  lineitem_id: -1,
  plan_id: -1,
  location_exclusion_ids: [],
  location_ids: [],
  market_ids: [],
  market_exclusion_ids: [],
  max_bid_cpm: null,
  measurement_requested: false,
  mediatype_ids: [],
  mediatype_exclusion_ids: [],
  min_concentration_factor: 0,
  network_ids: [],
  network_exclusion_ids: [],
  owner_ids: [],
  owner_organization_ids: [],
  package_exchange_id: null,
  package_organization_id: null,
  purchase_type: 'G',
  screen_frequency_cap: 0,
  site_exclusion_ids: [],
  site_ids: [],
  to_date: null,
  unit_exclusion_ids: [],
  unit_ids: [],
  unit_tags: [],
  unit_tag_exclusions: [],
  unitpack_ids: [],
  unitpack_exclusion_ids: [],
  lineitem_networkfreqcaps: [],
  creative_formats: [],
  creative_format_exclusions: [],
  organizationID: null,
  type: 'plans',
  min_concentration_value: 0,
};

const defaultEdsParams = {
  from_date: null,
  to_date: null,
  organization_id: null,
  unit_targeting: {
    package_id: null,
    lineitem_id: null,
    purchase_type: null,
    organization_id: null,
    owner_ids: [],
    location_ids: [],
    location_exclusion_ids: [],
    geofencegroup_ids: [],
    geofencegroup_exclusion_ids: [],
    mediatype_ids: [],
    mediatype_exclusion_ids: [],
    market_ids: [],
    market_exclusion_ids: [],
    network_ids: [],
    network_exclusion_ids: [],
    site_ids: [],
    site_exclusion_ids: [],
    unit_ids: [],
    unit_exclusion_ids: [],
    creative_formats: [],
    creative_format_exclusions: [],
    unit_tags: [],
    unit_tag_exclusions: [],
    unitpack_ids: [],
    unitpack_exclusion_ids: [],
  },
};

const GeofencesUtils = {
  appropriateToolTip,
  appropriateSearchPlaceholder,
  splitGenericGeofenceNames,

  defaultEcpmParams,
  defaultEdsParams,
};

export default GeofencesUtils;
